/**
 * GET menú dinámico del usuario según su rol y permisos.
 */
import axiosController from "helpers/axiosController";

const GETMenu = async (loggedUser) => {
  try {
    const { token } = loggedUser;

    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/rol/get_menu`,
      headers: {
        Accept: "text/plain",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axiosController.request(config);

    return response.data;
  } catch (error) {
    if (error.response) {
      return { status: error.response.status, data: error.response.data };
    } else if (error.request) {
      return { status: 500, message: "No se recibió respuesta del servidor" };
    } else {
      return { status: 400, message: "Error al realizar la solicitud" };
    }
  }
};

export default GETMenu;
